import { ChevronDown, LoaderCircle, Phone, PhoneCall } from "lucide-react";
import { useEffect, useState } from "react";

import { dial, onCallActivity } from "@/lib/ringoverPhone";

// Téléphone Ringover intégré : réduit à la touche d'appel hors appel, s'ouvre tout seul pendant un appel (sortant ou entrant)
export const PhoneCard = ({ ready, open, setOpen, phone }) => {
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    const box = document.getElementById("pl-sheet-phone-frame");
    if (!box) return undefined;
    const check = () => { const f = box.querySelector("iframe"); if (f) { f.addEventListener("load", () => setLoaded(true), { once: true }); setTimeout(() => setLoaded(true), 4000); } };
    const mo = new MutationObserver(check);
    mo.observe(box, { childList: true, subtree: true });
    check();
    return () => mo.disconnect();
  }, [ready]);
  useEffect(() => onCallActivity((active) => setOpen(active)), [setOpen]);
  return (
    <section className={`card ldx-phone${loaded ? " is-loaded" : ""}${open ? " is-open" : ""}`} data-testid="lead-inline-phone">
      <div className="ldx-phone__bar">
        {phone && <button type="button" className="ldx-phone__call" disabled={!loaded} onClick={() => dial(phone)} data-testid="lead-phone-call"><PhoneCall size={15} /> Appeler</button>}
        <button type="button" className="ldx-phone__head" onClick={() => setOpen(!open)} aria-expanded={open} data-testid="lead-phone-toggle">
          {loaded ? <Phone size={15} /> : <LoaderCircle size={15} className="spin" />}
          <b>{phone || "Téléphone Ringover"}</b>
          <small data-testid="lead-phone-state">{loaded ? (open ? "Réduire" : "Ouvrir") : "Chargement…"}</small>
          <ChevronDown size={14} className="ldx-cal__chev" />
        </button>
      </div>
      <div id="pl-sheet-phone-frame" />
    </section>
  );
};
